<template>
    <div>
        <b-radio :value="value" type="is-teal" size="is-small" :disabled="!availablePolicies.none && value !== '1'" :native-value="1" @input="handleInput">
          In Policy Only
        </b-radio>
        <br />

        <b-radio :value="value" type="is-teal" size="is-small" :disabled="!availablePolicies.soft && value !== '2'" :native-value="2" @input="handleInput">
          Allow Manager Notifications
        </b-radio>
        <br />

        <b-radio :value="value" :native-value="-1" type="is-teal" size="is-small" @input="handleInput" >
          Any
        </b-radio>
    </div>
</template>

<script>
    export default {
      name: 'PolicySelection',
      data() {
          return {
            policyValue: '',
          }
      },
      props: {
        availablePolicies: Object,
        value: {},
        size: {
          type: String,
          default: 'is-small'
        }
      },
      methods: {
        handleInput (val) {
          // console.log(val);
          this.policyValue = val;
          this.$emit('input', this.policyValue);
        }
      },
      watch:{
        value: function(){
          this.$emit('input', this.value);
        }
      }
    }
</script>

<style lang="scss" scoped>

</style>
